import React, { createContext, useState, useEffect, useReducer } from 'react'
import { song_list } from '../context/songs'

export const MusicPlayerContext = createContext( [{}, () => { }] )
const localState = JSON.parse( localStorage.getItem( 'PlayQueue' ) )

export const MusicPlayerProvider = ( props ) => {
  const songs = song_list

  const initalState = {
    audioPlayer: new Audio(),
    tracks: [
      ...songs
    ],
    currentTrackIndex: null,
    isPlaying: false,
    isRepeatOn: false,
    isShuffleOn: false,
    favorites: []
  }
  const [state, setState] = useState( initalState, [() => {
    // const localState = localStorage.getItem( 'PlayQueue' )
    // return localState ? JSON.parse( localState ) : []
    // localStorage.setItem( 'PlayQueue', JSON.stringify( state ) )
  }] || localState )

  useEffect( () => {
    localStorage.setItem( 'PlayQueue', JSON.stringify( state ) )
  }, [state] )

  return (
    <MusicPlayerContext.Provider value={[
      state,
      setState
    ]}>
      {props.children}
    </MusicPlayerContext.Provider>
  )
}